<template>
  <div id="app" :data-theme="themeKey" :class="themeClass">
    <!-- <loading ref="loading"></loading> -->
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <WechatQrModal />
    <CookieConsent />
  </div>
</template>
<script>
import router from './router';
import CookieConsent from './components/CookieConsent.vue';
import WechatQrModal from './components/WechatQrModal.vue';
import { getActiveTheme } from '@/config/site-theme';
// import Loading from './components/loading.vue';

export default {
  name: 'app',
  components: {
    CookieConsent,
    WechatQrModal,
    // Loading,
  },
  data() {
    return {
      theme: getActiveTheme(),
    }
  },
  computed: {
    themeKey() {
      return this.theme.key;
    },
    themeClass() {
      return this.theme.className;
    },
  },
  router,
  // watch: {
  //   $route(to, from) {
  //     this.showLoading();
  //   }
  // },
  // mounted() {
  //   this.$refs.loading.hide();
  // },
  // methods: {
  //   showLoading() {
  //     this.$refs.loading.show();
  //     setTimeout(() => {
  //       this.$refs.loading.hide();
  //     }, 1000);
  //   }
  // }
}
</script>
<!-- <style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
</style> -->
<style src="./styles/index.css" />
